module.exports = __webpack_public_path__ + "img/slide15.e5b5590c.png";